import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
import LazyLoad from 'react-lazyload';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import DevicesIcon from '@material-ui/icons/Devices';
import PersonIcon from '@material-ui/icons/Person';

import { api_host, api_auth } from '../../../../common/globals/constants';

import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment'
import 'moment/locale/es'  
import { Button, Divider, Table, TableRow, TableCell, Grid } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// Component styles
import styles from './styles';
import { indigo } from '@material-ui/core/colors';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Devices: forwardRef((props, ref) => <DevicesIcon {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
const Loading = (props) => (
    <div className="post loading">
        <h5>{props && props.t ? props.t('groups.loading') : /* keep simple static fallback */ 'Cargando...'}</h5>
    </div>
)
const sendValues = (value, nombre, descripcion, cliente_subcliente_id) => {
    let token = sessionStorage.getItem('key')
    let client_id = sessionStorage.getItem('client_id')
    let method = 'POST'
    if (value == 2){
        method = 'PATCH'
    }
    if (value == 3){
        method = 'DELETE'
    }
    return new Promise(resolve => {
        setTimeout(() => {
            if (value == 1) {
                fetch(api_host+`/reporte/general/cliente_subcliente/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, cliente_id: client_id}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            } else if(value == 2){
                fetch(api_host+`/reporte/general/cliente_subcliente/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, cliente_id: client_id, cliente_subcliente_id: cliente_subcliente_id}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            } else if(value == 3){
                fetch(api_host+`/reporte/general/cliente_subcliente/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, cliente_id: client_id, cliente_subcliente_id: cliente_subcliente_id}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            }
        }, 100);
    });
};

const sendValuesList = (value, usersList, objectivesList, cliente_subcliente_id) => {
    let token = sessionStorage.getItem('key')
    let client_id = sessionStorage.getItem('client_id')
    let method = 'PATCH'
    return new Promise(resolve => {
        setTimeout(() => {
            if (value == 1) {
                fetch(api_host+`/reporte/general/cliente_mapa_subcliente_usuarios/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, usuarios: usersList, cliente_id: client_id, cliente_subcliente_id: cliente_subcliente_id}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            } else if(value == 2){
                fetch(api_host+`/reporte/general/cliente_mapa_subcliente_objetivos/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, objetivos: objectivesList, cliente_id: client_id, cliente_subcliente_id: cliente_subcliente_id}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            }
        }, 100);
    });
};
class GroupsList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            //date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            addEl: null,
            editEl: null,
            deleteEl: null,
            usersEl: null,
            objectivesEl: null,
            values: {
                email: '',
                name: '',
                phone: '',
                cargo: '',
                emailEdit: '',
                nameEdit: '',
                phoneEdit: '',
                cargoEdit: '',
                objectivesEdit: []
            },
            valuesUsersEdit:{
                clientusersEdit: []
            },
            valuesSubEdit:{
                descriptionEdit: '',
                nameEdit: ''
            },
            valuesDeleted:{
                clientsub: '',
                name: ''
            },
            open: false,
            isValid: false,
            validEmail: false,
            validName: false,
            value: 0,
            valueCreate: 0,
            timezone: {},
            //isRefresh: this.props.params.isRefresh,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        let token = sessionStorage.getItem('key')
        Promise.all([
            fetch(api_host+`/reporte/general/usuarios/?token=${token}&start=${new Date().getTime()}`),
            fetch(api_host+`/reporte/general/cliente_subcliente_objetivos/?token=${token}&start=${new Date().getTime()}`),
            fetch(api_host+`/reporte/general/cliente_subcliente/?token=${token}&start=${new Date().getTime()}`)
        ])
            .then(([res1, res2, res3]) => {
                return Promise.all([res1.json(), res2.json(), res3.json()])
            })
            .then(([res1, res2, res3]) => {
                // Se define el state de acuerdo a la petición y respuesta de la promesa 
                if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
                    localStorage.setItem('isAuthenticated', false);
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(res1, res2, res3)
                    } catch (error) {
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                }
            }
        });
    }

    // Helper para procesar la data de la petición a la API
    processData = (data, dataSubClientObjectives, dataSubClient) => {
            let userList = data[0]
            let arrayRows = []
            Object.keys(dataSubClient).map((key0)=> {
                let rows = {}
                rows['clientesubclienteid'] = dataSubClient[key0].cliente_subcliente_id
                rows['nombre'] = dataSubClient[key0].nombre  
                rows['descripcion'] = dataSubClient[key0].descripcion 
                rows['objetivos'] = dataSubClient[key0].objetivos
                rows['clienteusuarios'] = dataSubClient[key0].cliente_usuarios
                arrayRows.push(rows)
            })
            this.setState({
                objectives: dataSubClientObjectives,
                users: data[0],
                subclient: dataSubClient,
                rows : arrayRows,
                isLoading: false,
                dataError: false,
            }); 
       
    }
    handleShowAdd = event => {
        this.setState({
            addEl: event.currentTarget,
            /*values:{
                subclientCreate: [-1]
            }*/
        });
    };

    handleCloseAdd = () => {
        this.setState({
            addEl: null,
            //validEmail: false,
            //validName: false,
        });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            valuesSubEdit:{
                descriptionEdit: value.descripcion,
                nameEdit: value.nombre,
                clientsubEdit: value.clientesubclienteid
            }
        });
    };

    handleCloseEdit = () => {
        this.setState({
            editEl: null,
            //validEmail: false,
            //validName: false,
        });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            valuesDeleted:{
                name: value.nombre,
                clientsub: value.clientesubclienteid
            }
        });
    };
    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleShowUsers = (event, value) => {
        this.setState({
            usersEl: event.currentTarget,
            valuesUsersEdit:{
                clientusersEdit: value.clienteusuarios,
                clientsubEdit: value.clientesubclienteid
            }
        });
    };

    handleCloseUsers = () => {
        this.setState({
            usersEl: null,
        });
    };

    handleShowObjectives = (event, value) => {
        this.setState({
            objectivesEl: event.currentTarget,
            values:{
                objectivesEdit: value.objetivos,
                clientsubEdit: value.clientesubclienteid
            }
        });
    };

    handleCloseObjectives = () => {
        this.setState({
            objectivesEl: null,
        });
    };
    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };
    handleFieldChangeEdit = (field, value) => {
        const newState = { ...this.state };
        newState.valuesSubEdit[field] = value;     
        this.setState(newState);
    };

    handleDeleted = async(value) => {
        const {addEl, editEl, valuesDeleted} = this.state;
        var valueMethod = 3
        var nombre = ""
        var descripcion = ""
        var cliente_subcliente_id = valuesDeleted.clientsub
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(valueMethod, nombre, descripcion, cliente_subcliente_id);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: true,
                    deleteEl: null

                });
                this.getDataFromAPI();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true
                });
            }
        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleSaved = async (value) => {
        const {addEl, editEl, values, valuesSubEdit} = this.state;
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
      
        var value = 0
        var nombre = ""
        var descripcion = ""
        var cliente_subcliente_id = 0 
        if (showAddEl){
            value = 1
            nombre = values.name
            descripcion = values.description
        } else if (showEditEl){
            value = 2
            nombre = valuesSubEdit.nameEdit
            descripcion = valuesSubEdit.descriptionEdit
            cliente_subcliente_id = valuesSubEdit.clientsubEdit
        } 
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(value, nombre, descripcion, cliente_subcliente_id);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: true,
                    editEl: null,
                    addEl: null,
                    usersEl: null,
                    objectivesEl: null,
                    validEmail: false,
                    validName: false,

                });
                this.getDataFromAPI();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true,
                });
            }
        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleSavedList = async (value) => {
        const {usersEl, objectivesEl, values, valuesSubEdit, valuesUsersEdit} = this.state;
        const showUsersEl = Boolean(usersEl);   
        const showObjectivesEl = Boolean(objectivesEl); 
      
        var value = 0
        var usersList = ""
        var objectivesList = ""
        var cliente_subcliente_id = 0
        if (showUsersEl){
            value = 1
            usersList = valuesUsersEdit.clientusersEdit
            cliente_subcliente_id = valuesUsersEdit.clientsubEdit
        } else if (showObjectivesEl){
            value = 2
            objectivesList = values.objectivesEdit
            cliente_subcliente_id = values.clientsubEdit
        } 
        try {
            this.setState({ isLoading: true });
            var ok = await sendValuesList(value, usersList, objectivesList, cliente_subcliente_id);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: true,
                    editEl: null,
                    addEl: null,
                    usersEl: null,
                    objectivesEl: null,
                    validEmail: false,
                    validName: false,

                });
                this.getDataFromAPI();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true,
                });
            }
        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
    };
    
    validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;      
        if (re.test(email)) {
            this.setState({
                validEmail: false,
            });
        } else {
            this.setState({
                validEmail: true,
            });
        }
    }
    validateName = (name) => {
        if (!name) {
            this.setState({
                validName: true,
            });
        } else {
            this.setState({
                validName: false,
            });
        }
    }
    validateDescription = (name) => {
        if (!name) {
            this.setState({
                validDescription: true,
            });
        } else {
            this.setState({
                validDescription: false,
            });
        }
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };
    handleCreateChange = (event, newValue) => {
        this.setState({
            valueCreate: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };

    handleToggleObjectives = value => () => {
        const {objectivesEdit, clientsubEdit} = this.state.values
        if (objectivesEdit[0] != -1) {
            const currentIndex = objectivesEdit.indexOf(parseInt(value));
            const newChecked = [...objectivesEdit];
            var check = false
            if(newChecked.includes(value)){
                newChecked.splice(currentIndex, 1);
            } else {
                newChecked.push(value)
            }
            this.setState({
                values:{
                    objectivesEdit: newChecked,
                    clientsubEdit: clientsubEdit
                }
            })
        } else{
            const newChecked = [];
            newChecked.push(value)
            this.setState({
                values:{
                    objectivesEdit: newChecked,
                    clientsubEdit: clientsubEdit
                }
            })
        }
    }

    handleToggleUsers = value => () => {
        const {clientusersEdit, clientsubEdit} = this.state.valuesUsersEdit
        if (clientusersEdit[0] != -1) {
            const currentIndex = clientusersEdit.indexOf(parseInt(value));
            const newChecked = [...clientusersEdit];
            var check = false
            if(newChecked.includes(value)){
                newChecked.splice(currentIndex, 1);
            } else {
                newChecked.push(value)
            }
            this.setState({
                valuesUsersEdit:{
                    clientusersEdit: newChecked,
                    clientsubEdit: clientsubEdit
                }
            })
        } else{
            const newChecked = [];
            newChecked.push(value)
            this.setState({
                valuesUsersEdit:{
                    clientusersEdit: newChecked,
                    clientsubEdit: clientsubEdit
                }
            })
        }
    }

    render() {
        const { classes, className, ...rest } = this.props;
        const { dataError, isLoading, rows, noMonCum, downCum, addEl, editEl, 
                deleteEl, open, isValid, validDescription, validName, value, timezone,
                profile, subclient, valueCreate, users, usersEl, objectives, objectivesEl} = this.state;
        const {phoneEdit, cargoEdit, typeEdit,timezoneIdEdit, profileIdEdit, 
                subclientEdit, subclientCreate, objectivesEdit} = this.state.values
        const {name} = this.state.valuesDeleted
        const {descriptionEdit, nameEdit} = this.state.valuesSubEdit
        const {clientusersEdit} = this.state.valuesUsersEdit
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };    
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl); 
        const showUsersEl = Boolean(usersEl); 
        const showObjectivesEl = Boolean(objectivesEl); 
        const rootClassName = classNames(classes.root, className);
  
        if (!dataError) {
            return (<FormattedChart t={this.props.t} classes={classes} rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden}
                                    handleCloseAdd={this.handleCloseAdd} handleShowAdd={this.handleShowAdd} showAddEl={showAddEl}
                                    handleFieldChange={this.handleFieldChange}
                                    handleCloseEdit={this.handleCloseEdit} handleShowEdit={this.handleShowEdit} showEditEl={showEditEl} 
                                    descriptionEdit={descriptionEdit} nameEdit={nameEdit} phoneEdit={phoneEdit} typeEdit={typeEdit}
                                    handleDeleted={this.handleDeleted} handleSaved={this.handleSaved}
                                    open={open} isValid={isValid} handleClose={this.handleClose}
                                    handleCloseDelete={this.handleCloseDelete} handleShowDelete={this.handleShowDelete} showDeleteEl={showDeleteEl}
                                    name={name} validDescription={validDescription} validateDescription={this.validateDescription} 
                                    validName={validName} validateName={this.validateName} value={value} handleChange={this.handleChange}
                                    timezone={timezone} timezoneIdEdit={timezoneIdEdit} profileIdEdit={profileIdEdit}
                                    profile={profile} subclient={subclient} subclientEdit={subclientEdit}
                                    handleToggleObjectives={this.handleToggleObjectives} cargoEdit={cargoEdit}
                                    valueCreate={valueCreate} handleCreateChange={this.handleCreateChange}
                                    handleToggleUsers={this.handleToggleUsers} subclientCreate={subclientCreate} 
                                    users={users} showUsersEl={showUsersEl} handleShowUsers={this.handleShowUsers}
                                    handleCloseUsers={this.handleCloseUsers} handleShowObjectives={this.handleShowObjectives}
                                    handleCloseObjectives={this.handleCloseObjectives} objectives={objectives}
                                    showObjectivesEl={showObjectivesEl} objectivesEdit={objectivesEdit}
                                    clientusersEdit={clientusersEdit} handleFieldChangeEdit={this.handleFieldChangeEdit}
                                    handleSavedList={this.handleSavedList}/>) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    return (
        <div>
            { props.rows == null  ? 
                <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    </Grid>
            <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                {props.t ? props.t('groups.loading') : 'Cargando Información'}
                    </Grid>
                </Grid>
            :
                <div style={{ maxWidth: "100%" }}>
                    {/*<Button style={{backgroundColor: 'white'}} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> Agregar contacto </Typography>
                    </Button>*/}
                    <MaterialTable
                        
                        icons={tableIcons}
                        columns={[
                            { width: 100, title: props.t ? props.t('groups.table.column.name') : "Nombre", field: "nombre"/*, defaultGroupOrder: 0*/,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            } },
                            { width: 100, title: props.t ? props.t('groups.table.column.description') : "Descripción", field: "descripcion" ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            } },
                            { width: 100, title: props.t ? props.t('groups.table.column.edit') : "Editar", field: "editar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#979797',
                                color: '#FFF'
                            }, hidden: true },
                            { width: 100, title: props.t ? props.t('groups.table.column.delete') : "Eliminar", field: "eliminar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                            }, hidden: true},
                            { width: 100, title: "clientesubclienteid", field: "clientesubclienteid"/*, type: "numeric"*/,headerStyle: {
                                  backgroundColor: '#0c0033',
                                  color: '#FFF'
                            }, hidden: true},
                            { width: 100, title: "subCliente", field: "subCliente"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                                }, hidden: true},
                            { width: 100, title: "objetivos", field: "objetivos"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                                }, hidden: true},
                            { width: 100, title: "cliente_usuarios", field: "clienteusuarios"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                                }, hidden: true}
                        ]}
                        data={props.rows} 
                        title=" "
                        localization={{
                            grouping: {
                                groupedBy: props.t ? props.t('groups.table.groupedBy') : 'Agrupar por:',
                                placeholder: props.t ? props.t('groups.table.groupPlaceholder') : 'Arrastre los encabezados aquí, para agrupar',
                            },
                            body: {
                                emptyDataSourceMessage: props.t ? props.t('groups.table.empty') : 'No hay datos'
                            },
                            toolbar: {
                                searchTooltip: props.t ? props.t('groups.table.search.tooltip') : 'Buscar',
                                searchPlaceholder: props.t ? props.t('groups.table.search.placeholder') : 'Buscar'
                            },
                            pagination: {
                                labelRowsSelect: props.t ? props.t('groups.table.pagination.rows') : 'Filas',
                                labelDisplayedRows: props.t ? props.t('groups.table.pagination.displayed') : ' {from}-{to} de {count}',
                                firstTooltip: props.t ? props.t('groups.table.pagination.first') : 'Pri. pág.',
                                previousTooltip: props.t ? props.t('groups.table.pagination.previous') : 'Pág. previa',
                                nextTooltip: props.t ? props.t('groups.table.pagination.next') : 'Sig. pág.',
                                lastTooltip: props.t ? props.t('groups.table.pagination.last') : 'Últ. pág'
                            },
                            header: {
                                actions: '',
                                headerStyle: {
                                    backgroundColor: '#979797',
                                    color: '#FFF'
                                }
                            },
                        }}
                        options={{
                            grouping: true,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            }
                        }}
                        actions={[
                            {
                                icon: AddCircleOutlineIcon,
                                    tooltip: props.t ? props.t('groups.actions.add') : 'Agregar subcliente',
                                isFreeAction: true,
                                //onClick: (event) => alert("You want to add a new row")
                                onClick: props.handleShowAdd
                            },
                            {
                                icon: Edit,
                                    tooltip: props.t ? props.t('groups.actions.edit') : 'Editar subcliente',
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => props.handleShowEdit(event, rowData)
                            },
                            
                            rowData => ({
                                icon: DeleteOutline,
                                tooltip: props.t ? props.t('groups.actions.delete') : 'Eliminar subcliente',
                                onClick: (event, rowData) => props.handleShowDelete(event, rowData),
                                disabled: rowData.eliminar,
                                hidden: rowData.eliminar
                            }),
                            rowData => ({
                                icon: PersonIcon,
                                tooltip: (props.t ? props.t('groups.actions.usersList') : 'Lista usuarios asociados: ') + rowData.clienteusuarios.length+' usuario(s)',
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => props.handleShowUsers(event, rowData)
                            }),
                            rowData => ({
                                icon: DevicesIcon,
                                tooltip: (props.t ? props.t('groups.actions.objectivesList') : 'Lista objetivos asociados: ') + rowData.objetivos.length+' objetivo(s)',
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => props.handleShowObjectives(event, rowData)
                            }),
                        ]}
                    />
                    {/* Modal que despliega el sublicliente, para editar*/}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showEditEl}
                        onClose={props.handleCloseEdit}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showEditEl}>
                            <PerfectScrollbar>                            
                                    <Portlet
                                        className={props.rootClassName}
                                    >
                                        <PortletHeader>
                                            <PortletLabel
                                                    //subtitle="Actualizar Contraseña"
                                                    title={props.t ? props.t('groups.modal.title') : 'Configurar subcliente'}
                                                />
                                            <IconButton  onClick={props.handleCloseEdit}><CloseIcon/></IconButton>
                                        </PortletHeader>
                                        <PortletContent className={props.classes.porletContent}>
                                            <form className={props.classes.form}>
                                                <TextField
                                                    required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validName}
                                                    helperText={props.validName ? (props.t ? props.t('groups.form.helper.invalidName') : 'Por favor ingrese un nombre válido') : ' '}
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('groups.form.name') : 'Nombre'}
                                                    name="nameEdit"
                                                    onChange={event =>
                                                        props.handleFieldChangeEdit('nameEdit', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.nameEdit}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateDescription(event.target.value)
                                                    }
                                                    error={props.validDescription}
                                                    helperText={props.validDescription ? (props.t ? props.t('groups.form.helper.invalidDescription') : 'Por favor ingrese una descripción válida') : ' '}
                                                    required
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('groups.form.description') : 'Descripción'}
                                                    name="descriptionEdit"
                                                    onChange={event =>
                                                        props.handleFieldChangeEdit('descriptionEdit', event.target.value)
                                                    }
                                                    type="description"
                                                    value={props.descriptionEdit}
                                                    variant="outlined"
                                                />
                                            </form>
                                        </PortletContent>
                                            <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleSaved}
                                            >
                                                {props.t ? props.t('groups.button.save') : 'Guardar'}
                                            </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseEdit}
                                            >
                                                {props.t ? props.t('groups.button.cancel') : 'Cancelar'}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    {/* Modal que despliega el sublicliente, para crear*/}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showAddEl}
                        onClose={props.handleCloseAdd}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showAddEl}>
                            <PerfectScrollbar>                            
                                    <Portlet
                                        className={props.rootClassName}
                                    >
                                        <PortletHeader>
                                            <PortletLabel
                                                //subtitle="Actualizar Contraseña"
                                                title={props.t ? props.t('groups.modal.title') : 'Configurar subcliente'}
                                            />
                                            <IconButton  onClick={props.handleCloseAdd}><CloseIcon/></IconButton>
                                        </PortletHeader>
                                        <PortletContent className={props.classes.porletContent}>
                                            <form className={props.classes.form}>
                                                <TextField
                                                    required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validName}
                                                    helperText={props.validName ? (props.t ? props.t('groups.form.helper.invalidName') : 'Por favor ingrese un nombre válido') : ' '}
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('groups.form.name') : 'Nombre'}
                                                    name="name"
                                                    onChange={event =>
                                                        props.handleFieldChange('name', event.target.value)
                                                    }
                                                    type="text"
                                                    //value={props.name}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateDescription(event.target.value)
                                                    }
                                                    error={props.validDescription}
                                                    helperText={props.validDescription ? (props.t ? props.t('groups.form.helper.invalidDescription') : 'Por favor ingrese un descripción válido') : ' '}
                                                    required
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('groups.form.description') : 'Descripción'}
                                                    name="description"
                                                    onChange={event =>
                                                        props.handleFieldChange('description', event.target.value)
                                                    }
                                                    type="description"
                                                    //value={props.adreess}
                                                    variant="outlined"
                                                />
                                            </form>
                                        </PortletContent>
                                            <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleSaved}
                                            >
                                                {props.t ? props.t('groups.button.save') : 'Guardar'}
                                            </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseAdd}
                                            >
                                                {props.t ? props.t('groups.button.cancel') : 'Cancelar'}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    {/* Modal que despliega lista de objetivos, relacionados con el subcliente*/}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showObjectivesEl}
                        onClose={props.handleCloseObjectives}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showObjectivesEl}>
                            <Portlet
                                className={props.rootClassName}
                            >
                                <PortletHeader>
                                        <PortletLabel
                                        //subtitle="Actualizar Contraseña"
                                        title={props.t ? props.t('groups.modal.objectivesTitle') : 'Información de objetivos en el subcliente'}
                                    />
                                    <Grid>
                                    <IconButton  onClick={props.handleCloseObjectives}><CloseIcon/></IconButton>
                                    </Grid>
                                </PortletHeader>
                                <PerfectScrollbar>
                                    <Paper style={{ minHeight: 50, 
                                                    maxHeight: 400, 
                                                    maxWidth: '100%',
                                                    overflow: 'auto'
                                                }}
                                            className={props.classes.customScrollBar}>
                                        <List disablePadding>
                                                <ListItem>
                                                <Grid container spacing={4}>
                                                    <Grid item xs={8} sm={8} md={8} xl={8}>
                                                        <ListItemText primary={props.t ? props.t('groups.objectives.header.name') : 'nombre'} />
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} xl={3}>
                                                        <ListItemText style={{paddingLeft:20}} primary={props.t ? props.t('groups.objectives.header.nodes') : 'nodos'} />
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                            {Object.keys(props.objectives).map(key => (
                                                <LazyLoad resize overflow once={true} key={props.objectives[key].objetivo_id} placeholder={<Loading t={props.t}/> }>
                                                <ListItem
                                                    className={props.classes.listItem}
                                                    component="div"
                                                    key={props.objectives[key].objetivo_id} 
                                                    role={undefined} 
                                                    dense button
                                                    onClick={props.handleToggleObjectives(props.objectives[key].objetivo_id)}
                                                >
                                                    <Grid container
                                                        spacing={4}>
                                                    <Grid
                                                        item
                                                        xs={9}
                                                        sm={9}
                                                        md={9}
                                                        xl={9}                                    
                                                    >
                                                    <ListItemText 
                                                                id={props.objectives[key].objetivo_id} 
                                                                primary={props.objectives[key].objetivo_nombre_mod} 
                                                                secondary={props.objectives[key].servicio_nombre_mod}
                                                                /> 
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={1}
                                                        sm={1}
                                                        md={1}
                                                        xl={1}                                    
                                                    >
                                                    <ListItemText classes={{primary: props.classes.listItemText}} 
                                                                id={props.objectives[key].objetivo_id} 
                                                                primary={props.objectives[key].nodos} 
                                                                //secondary={props.objectives[key].descripcion}
                                                                /> 
                                                    </Grid>
                                                    
                                                    <Grid
                                                        item
                                                        xs={1}
                                                        sm={1}
                                                        md={1}
                                                        xl={1}                                    
                                                    >
                                                    <ListItemIcon className={props.classes.listItemIcon} >
                                                        <Checkbox
                                                            style ={{
                                                                color: "#f57000",
                                                            }}
                                                            edge="start"
                                                            checked={props.objectivesEdit.includes(props.objectives[key].objetivo_id)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': key }}
                                                        />
                                                    </ListItemIcon>  
                                                    </Grid>
                                                    </Grid>                                  
                                                </ListItem>
                                                </LazyLoad>
                                            ))}
                                        </List>
                                    </Paper> 
                                </PerfectScrollbar>
                                <PortletFooter className={props.classes.portletFooter} align="center">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={props.handleSavedList}
                                    >
                                        {props.t ? props.t('groups.button.save') : 'Guardar'}
                                    </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        onClick={props.handleCloseObjectives}
                                    >
                                        {props.t ? props.t('groups.button.cancel') : 'Cancelar'}
                                    </Button>
                                </PortletFooter>
                            </Portlet>
                        </Fade>
                    </Modal>
                    {/* Modal que despliega lista de usuarios, relacionados con el subcliente*/}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showUsersEl}
                        onClose={props.handleCloseUsers}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showUsersEl}>
                            <Portlet
                                className={props.rootClassName}
                            >
                                <PortletHeader>
                                        <PortletLabel
                                        //subtitle="Actualizar Contraseña"
                                        title={props.t ? props.t('groups.modal.usersTitle') : 'Información de usuarios en el subcliente'}
                                    />
                                    <Grid>
                                        <IconButton  onClick={props.handleCloseUsers}><CloseIcon/></IconButton>
                                    </Grid>
                                </PortletHeader>
                                <PerfectScrollbar>
                                    <Paper style={{ minHeight: 50, 
                                                    maxHeight: 400, 
                                                    maxWidth: '100%',
                                                    overflow: 'auto'
                                                }}
                                            className={props.classes.customScrollBar}>
                                        <List disablePadding>
                                            {Object.keys(props.users).map(key => ( 
                                                <LazyLoad resize overflow once={true} key={props.users[key].cliente_usuario_id} placeholder={<Loading t={props.t}/> }>
                                                <ListItem
                                                    className={props.classes.listItem}
                                                    component="div"
                                                    key={props.users[key].cliente_usuario_id} 
                                                    role={undefined} 
                                                    dense button
                                                    onClick={props.handleToggleUsers(props.users[key].cliente_usuario_id)}
                                                >
                                                    <ListItemText classes={{primary: props.classes.listItemText}} 
                                                                id={props.users[key].cliente_usuario_id} 
                                                                primary={props.users[key].nombre} 
                                                                secondary={props.users[key].email}/> 
                                                    <ListItemIcon className={props.classes.listItemIcon} >
                                                        <Checkbox
                                                            style ={{
                                                                color: "#f57000",
                                                            }}
                                                            edge="start"
                                                            checked={props.clientusersEdit.includes(props.users[key].cliente_usuario_id)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': key }}
                                                        />
                                                    </ListItemIcon>                                            
                                                </ListItem>
                                                </LazyLoad>
                                            ))}
                                        </List>
                                    </Paper> 
                                </PerfectScrollbar>
                                <PortletFooter className={props.classes.portletFooter} align="center">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={props.handleSavedList}
                                    >
                                        {props.t ? props.t('groups.button.save') : 'Guardar'}
                                    </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        onClick={props.handleCloseUsers}
                                    >
                                        {props.t ? props.t('groups.button.cancel') : 'Cancelar'}
                                    </Button>
                                </PortletFooter>
                            </Portlet>
                        </Fade>
                    </Modal>
                    {/* Modal que se despliega al eliminar */}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showDeleteEl}
                        onClose={props.handleCloseDelete}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showDeleteEl}>
                            <PerfectScrollbar>
                                <div className={props.classes.modalDeleted}>                             
                                    <Portlet
                                        className={props.rootClassName}
                                    >
                                        <PortletLabel
                                            className={props.classes.portletFooter}
                                            //subtitle="Actualizar Contraseña"
                                            title={props.t ? props.t('groups.deleteConfirm', { name: props.name }) : ("¿Esta seguro que desea eliminar el grupo "+props.name+"? ")}
                                        />
                                        <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleDeleted}
                                            >
                                                {props.t ? props.t('groups.button.accept') : 'Aceptar'}
                                            </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseDelete}
                                            >
                                                {props.t ? props.t('groups.button.cancel') : 'Cancelar'}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>                          
                                </div>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    {/* Snackbar mensaje de confirmacion*/}
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={props.open}
                        autoHideDuration={6000}
                        onClose={props.handleClose}
                        >
                            <SnackbarContent
                                className={props.isValid ? props.classes.snackContentOk
                                            : props.classes.snackContent}
                                aria-describedby="client-snackbar"
                                message={
                                    props.isValid ?
                                            <span id="client-snackbar" className={props.classes.message}>
                                                <CheckCircleIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {props.t ? props.t('groups.snackbar.success') : 'Proceso Exitoso'}
                                            </span>
                                        :	<span id="client-snackbar" className={props.classes.message}>
                                                <ErrorIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {props.t ? props.t('groups.snackbar.error') : "Ha ocurrido un error, intente nuevamente. (Asegurece que el campo 'nombre', no este vacio)"}
                                            </span>

                                }
                                action={[
                                    <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                                        <CloseIcon className={props.classes.icon}/>
                                    </IconButton>
                                ]}
                            />
                    </Snackbar>
                </div>
                
            }
            </div>
        )

}

export default compose(withRouter, withStyles(styles), withTranslation())(GroupsList);